import { useAppConfig } from "./contexts";

export const Logo = () => {
  const appConfig = useAppConfig();
  return <img src="/assets/logo.svg" alt={appConfig.name} width="150" />;
};
